import React, { useContext } from 'react'
import product1 from '@assets/images/Advertisement/product1.png'
import product2 from '@assets/images/Advertisement/product2.png'
import product3 from '@assets/images/Advertisement/product3.png'
import product4 from '@assets/images/Advertisement/product4.png'
import product5 from '@assets/images/Advertisement/product5.png'
import product6 from '@assets/images/Advertisement/product6.png'
import productDark1 from '@assets/images/Advertisement/darkModeImages/productDark1.png'
import productDark2 from '@assets/images/Advertisement/darkModeImages/productDark2.png'
import productDark3 from '@assets/images/Advertisement/darkModeImages/productDark3.png'
import productDark4 from '@assets/images/Advertisement/darkModeImages/productDark4.png'
import productDark5 from '@assets/images/Advertisement/darkModeImages/productDark5.png'
import productDark6 from '@assets/images/Advertisement/darkModeImages/productDark6.png'
import styles from '@shared/components/Advertisement/ProductFeature/ProductFeature.module.scss'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'
import MyImage from '@shared/components/myImage'

const ProductFeature = () => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)

  const productFeaturesConfig = [
    {
      title: 'Real Time Scores',
      description: 'Fastest live scores, detailed commentary,match stats, squad info, and scorecards.',
      image: stateGlobalEvents?.darkModeEna === 'dark' ? productDark1 : product1
    },
    {
      title: 'In Depth Analytics',
      description: 'Detailed player profiles featuring career statistics, records, and performance insights.',
      image: stateGlobalEvents?.darkModeEna === 'dark' ? productDark2 : product2
    },

    {
      title: 'Team Insights',
      description: 'Fastest live scores, detailed commentary,match stats, squad info, and scorecards.',
      image: stateGlobalEvents?.darkModeEna === 'dark' ? productDark3 : product3
    },
    {
      title: 'Monetization Strategy',
      description: 'Fastest live scores, detailed commentary,match stats, squad info, and scorecards.',
      image: stateGlobalEvents?.darkModeEna === 'dark' ? productDark4 : product4
    },
    {
      title: 'Player Comparison',
      description: 'Real-time odds data and extensive fancy coverage with odds history.',
      image: stateGlobalEvents?.darkModeEna === 'dark' ? productDark5 : product5
    },
    {
      title: 'Comprehensive Series',
      description: 'Detailed player profiles featuring career statistics, records, and performance insights',
      image: stateGlobalEvents?.darkModeEna === 'dark' ? productDark6 : product6
    }
  ]
  return (
    <section className={styles.productFeature}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.prodHead}>Product Features</span>
        </div>

        <div className={styles.featureGrid}>
          {productFeaturesConfig.slice(0, 3).map((data, i) => (
            <div key={i} className={styles.featureCard}>
              <MyImage src={data.image} alt={data.title} width={300} height={350}/>
            </div>
          ))}
        </div>

        <div className={styles.descriptionBox}>
          {productFeaturesConfig.slice(0, 3).map((data, i) => (
            <div key={i} className={styles.featureText}>
              <h3>{data.title}</h3>
              <p>{data.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.featureGrid}>
          {productFeaturesConfig.slice(3).map((data, i) => (
            <div key={i} className={styles.featureCard}>
              <MyImage src={data.image} alt={data.title} width={300} height={350}/>
            </div>
          ))}
        </div>

        <div className={styles.descriptionBox}>
          {productFeaturesConfig.slice(3).map((data, i) => (
            <div key={i} className={styles.featureText}>
              <h3>{data.title}</h3>
              <p>{data.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.marqueeHeader}>
        <h3>Product Features</h3>
      </div>
      <div className={`${styles.smcontainer} ${styles.hiddenSm}`}>
        <div className={styles.marqueeContainer}>
          {productFeaturesConfig.map((data, i) => (
            <div key={data.title} className={styles.marqueeItem}>
              <div className={styles.imgMarquee}>
                <MyImage className={styles.imageWrapper} src={data.image} alt={data.title}/>
              </div>

              <div className={styles.MarWrapper}>
                <h3>{data.title}</h3>
                <p>{data.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
export default ProductFeature
